import {
  Alert,
  Button,
  Card,
  CardActions,
  CardContent,
  IconButton,
} from "@mui/material";
import { AddCircleRounded, Delete } from "@mui/icons-material";
import CustomTextField from "../../Custom/CustomTextField";
import NoListItems from "../../Custom/NoListItems";
import { trashStyles } from "../../../context/customStyles";
import DisplayResources from "../../DisplayItems/DisplayResources";
import DisplayQuestions from "../../DisplayItems/DisplayQuestions";
import ListLoader from "../../DisplayItems/SkeletonLoaders/ListLoader";
import { VisuallyHiddenInput } from "../../Custom/InputFile";
const ModExamContent = ({
  examId,
  deleting,
  setDeleting,
  deleteExam,
  exam,
  changesMade,
  setExam,
  setChangesMade,
  visibleQuestion,
  visibleResources,
  loading,
  resources,
  setShowQuestionModal,
  questions,
  saving,
  handleSave,
  setIndex,
  setResources,
  setQuestionSelectedId,
}) => {
  function appendResource(event) {
    setResources([
      ...resources,
      {
        name: event.target.files[0].name
          .replace(/\.[^/.]+$/, "")
          .replace(/[^a-zA-Z0-9]/g, " "),
        file: event.target.files[0],
        localLink: URL.createObjectURL(event.target.files[0]),
      },
    ]);
    setChangesMade({
      ...changesMade,
      resources: true,
    });
  }

  return (
    <div className="page-box">
      <Card
        className="card-page"
        sx={{
          boxShadow: "var(--box-shadow)",
          borderRadius: "var(--borderRadius)",
        }}
      >
        <div className="header">
          <h1>{examId !== "new" ? "Edit Exam" : "New Exam"}</h1>
          {examId !== "new" && (
            <IconButton
              style={trashStyles}
              color="error"
              className="icon-button"
              onClick={() => setDeleting(true)}
            >
              <Delete fontSize="inherit" color="error" />
            </IconButton>
          )}
        </div>
        <CardContent className="card-content">
          {deleting ? (
            <Alert
              type="error"
              severity="error"
              color="error"
              variant="filled"
              className="card-alert"
              sx={{
                "& .MuiAlert-action": {
                  padding: 0,
                  gap: 1,
                  alignItems: "center",
                },
              }}
              action={[
                <Button
                  color="ghostBlack"
                  variant="contained"
                  disableElevation
                  className="px-4 py-1"
                  key="cancel"
                  onClick={() => setDeleting(false)}
                >
                  Cancel
                </Button>,
                <Button
                  color="ghostRed"
                  variant="contained"
                  className="px-4 py-1"
                  disableElevation
                  key="delete"
                  onClick={() => deleteExam()}
                >
                  Delete
                </Button>,
              ]}
            >
              Are you sure you would like to delete this exam?
            </Alert>
          ) : (
            <Alert
              type="error"
              severity="error"
              color="error"
              className="card-alert"
              variant="filled"
            >
              All changes made to the exam, resources and questions need to be
              saved below
            </Alert>
          )}

          <div className="rows">
            <div className="content-group">
              <h4 className="italic-subtitle">Exam Details</h4>
              <form
                className="d-flex gap-2 flex-column"
                style={{ width: "100%" }}
              >
                <CustomTextField
                  color="black"
                  label="Title"
                  inputProps={{ maxLength: 50 }}
                  error={!exam.name && changesMade.exam}
                  required
                  fullWidth
                  value={exam ? exam.name : ""}
                  onChange={(e) => {
                    setExam({ ...exam, name: e.target.value });
                    setChangesMade({ ...changesMade, exam: true });
                  }}
                />
                <CustomTextField
                  color="black"
                  label="Subtitle"
                  inputProps={{ maxLength: 50 }}
                  error={!exam.description && changesMade.exam}
                  required
                  fullWidth
                  value={exam ? exam.description : ""}
                  onChange={(e) => {
                    setExam({ ...exam, description: e.target.value });
                    setChangesMade({ ...changesMade, exam: true });
                  }}
                />
              </form>
            </div>
            <hr style={{ margin: 0 }} />
            <div className="content-group">
              <h4 className="italic-subtitle">
                <div>Resources</div>
                <Button
                  color="ghostBlue"
                  variant="contained"
                  disabled={visibleResources.length === 2 || loading}
                  startIcon={<AddCircleRounded color="inherit" />}
                  disableElevation
                  sx={{
                    fontStyle: "normal",
                    padding: "4px 12px",
                  }}
                  className="input-file"
                  component="label"
                  htmlFor="file-input-resource"
                >
                  Add Resource
                </Button>
                <VisuallyHiddenInput
                  type="file"
                  id="file-input-resource"
                  onChange={appendResource}
                />
              </h4>
              <div className="container-box resources ">
                {visibleResources.length === 0 && !loading && (
                  <NoListItems
                    text="Add a resource above"
                    customHeight="7.5rem"
                  />
                )}
                {loading && <ListLoader count={2} />}
                {resources.length > 0 && (
                  <DisplayResources
                    resources={resources}
                    setResources={setResources}
                    changesMade={changesMade}
                    setChangesMade={setChangesMade}
                  />
                )}
              </div>
            </div>
          </div>
          <hr />

          <div className="content-group pb-0">
            <h4 className="italic-subtitle">
              <div>Questions</div>
              <Button
                color="ghostBlue"
                variant="contained"
                disabled={loading}
                className="py-1"
                startIcon={<AddCircleRounded color="inherit" />}
                disableElevation
                onClick={() => setShowQuestionModal("active")}
              >
                Add Question
              </Button>
            </h4>
            <div className="container-box questions">
              {visibleQuestion.length === 0 && !loading && (
                <NoListItems
                  text="Add a question above"
                  customHeight="calc(100dvh + 33.5rem)"
                />
              )}

              {loading && <ListLoader count={4} />}

              {questions.length > 0 && (
                <DisplayQuestions
                  questions={questions}
                  setQuestionId={setQuestionSelectedId}
                  setOpen={setShowQuestionModal}
                  setIndex={setIndex}
                />
              )}
            </div>
          </div>
        </CardContent>
        <CardActions className="float-actions">
          <Button
            href={"/exams"}
            color="ghostBlack"
            variant="contained"
            disableElevation
            sx={{ width: "8rem" }}
            className="py-2 nav-link"
          >
            cancel
          </Button>
          <Button
            color="black"
            variant="contained"
            disabled={
              (!exam.title && !exam.description) ||
              saving ||
              (changesMade.exam === false &&
                changesMade.resources === false &&
                changesMade.questions === false)
            }
            disableElevation
            sx={{ width: "8rem", marginLeft: 0 }}
            className="py-2"
            onClick={handleSave}
          >
            {saving ? "Saving ..." : "Save"}
          </Button>
        </CardActions>
      </Card>
    </div>
  );
};

export default ModExamContent;
